import TaskManagerEditDto from './TaskManagerEditDto';

export class OptimizeUnitTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.unitOptimizer = null;

        /** @type {number} */
        this.optimizationPipelineLog = null;
    }

    /**
     * @typedef {Object} _OptimizeUnitTaskEditDto  Props
     * @property {number} unitOptimizer
     * @property {number} optimizationPipelineLog
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _OptimizeUnitTaskEditDto Props} OptimizeUnitTaskEditDto Props
     */
    /**
     *
     * @param {OptimizeUnitTaskEditDto Props} props
     * @returns {OptimizeUnitTaskEditDto}
     */
    setup(props) {
        super.setup(props);

        this.unitOptimizer = props.unitOptimizer;
        this.optimizationPipelineLog = props.optimizationPipelineLog;

        return this;
    }
}

export default OptimizeUnitTaskEditDto;